export const TRANSFER_STATUS = {
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  WITHDRAWN: 'WITHDRAWN',
  EXPIRED: 'EXPIRED',
  SUPERSEDED: 'SUPERSEDED'
} as const

export type TransferStatus = typeof TRANSFER_STATUS[keyof typeof TRANSFER_STATUS]

export interface Transfer {
  id: string
  status: TransferStatus
  chargerSerial: string
  siteAddress?: string
  installerName?: string
  customerEmail: string
  expiresAt: number
}

export class TransferNotFoundError extends Error {
  constructor () {
    super('transfer_not_found')
  }
}

export class TransferEmailMismatchError extends Error {
  constructor () {
    super('email_mismatch')
  }
}

export class TransferSessionExpiredError extends Error {
  constructor () {
    super('session_expired')
  }
}

export class TransferNotActiveError extends Error {
  readonly transferStatus?: TransferStatus

  constructor (transferStatus?: TransferStatus) {
    super('transfer_not_active')
    this.transferStatus = transferStatus
  }
}
